module.exports = "search-hit"